(function ($, Drupal, drupalSettings) {
  Drupal.behaviors.ostersale = {
    attach: function attach(context) {
      function copyText($this) {
        var copyText = $this.parent().find('.copyCodeValue');
        if (copyText.length > 0) {
          copyText = copyText[0];
          copyText.select();
          copyText.setSelectionRange(0, 99999); // For mobile devices

          // Copy the text inside the text field
          navigator.clipboard.writeText(copyText.value)
          .then(() => {
            $this.addClass('is-copied');
            setTimeout(function() {
              $this.removeClass('is-copied');
            }, 1000);
          });
        }
      }

      function clickEvent() {
        const $this = $(this);
        copyText($this);
      }

      $('.copyCode').each(function() {
        $(this).on('click', clickEvent);
      })

      // var audio = document.getElementById("siteBgMusic");
      // if (audio.paused) {
      //   $(document).on('click touch', function() {
      //     audio.play();
      //     $(document).off('click touch');
      //   });
      // }
    }
  };

  Drupal.behaviors.ostersale_to_top = {
    attach: function attach(context) {
      var toTop = $('#toTop');

      $(window).scroll(function () {
        var $this = $(this)
        $this.scrollTop() > 200 ? toTop.addClass('show') : toTop.removeClass('show');
      });

      toTop.click(function () {
        $('html, body').animate({ scrollTop: 0 }, 500)
        return false
      })
    }
  };

  Drupal.behaviors.ostersale_nav = {
    attach: function attach(context) {
      var navFixed = $('.site-header__fixable');
      var topOffset = 0, toolbarOffset = 0;

      if ($('body').hasClass('toolbar-fixed')) {
        topOffset += 53;
      }

      if (
        $('body').hasClass('toolbar-horizontal') &&
        $('body').hasClass('toolbar-tray-open')
      ) {
        toolbarOffset = 60;
      }
      if (topOffset > 0) {
        navFixed.css('top', (topOffset + toolbarOffset) + 'px');
      }

      $(window).scroll(function () {
        var $this = $(this);
        $this.scrollTop() > 0 ? navFixed.addClass('scrolled') : navFixed.removeClass('scrolled');

        if (toolbarOffset > 0) {
          if ($this.scrollTop() > topOffset) {
            navFixed.css('top', topOffset + 'px');
          } else{
            navFixed.css('top', ((topOffset + toolbarOffset) - $this.scrollTop()) + 'px');
          }
        }
      });
    }
  };
})(jQuery, Drupal, drupalSettings);
